export const OptionsJSONTemplate = [{
    "VALID_VALUE_ID": "",
    "VALID_VALUE_SHORT_DESC": "",
    "VALID_VALUE_DESCRIPTION": "",
    "PARAMETER_ID": "",
    "PARAMETER": "",
    "FILTER1": null,
    "FILTER2": null,
    "FILTER3": null,
    "FILTER4": null,
    "COUNTER": 2,
    "ENTITY": "",
    "VERSION": 1,
    "ATTRIBUTE1": null,
    "ATTRIBUTE2": null,
    "VALID_VALUE_ADDITIONAL_TEXT": null
}];

export const OptionsJSONTemplate2 = {
    "VALID_VALUE_ID": "",
    "VALID_VALUE_SHORT_DESC": "",
    "VALID_VALUE_DESCRIPTION": "",
    "PARAMETER_ID": "",
    "PARAMETER": "",
    "FILTER1": null,
    "FILTER2": null,
    "FILTER3": null,
    "FILTER4": null,
    "COUNTER": 2,
    "ENTITY": "",
    "VERSION": 1,
    "ATTRIBUTE1": null,
    "ATTRIBUTE2": null,
    "VALID_VALUE_ADDITIONAL_TEXT": null
};

// export const FieldJSONTemplate = {
//     "name": "ModeDetails",
//     "label": "Declaration",
//     "type": "dropdown",
//     "dataType": "string",
//     "visible": false,
//     "required": true,
//     "api": {
//         "url": "",
//         "label": "",
//         "value": "",
//         "displayPattern": ""
//     },
//     "dependent": [
//         {
//             "title": "",
//             "field": ""
//         }
//     ]
// };

export const FieldJSONTemplate = 
    {
        fieldDefinition: {
          length: 50,
          required: false,
          wrapping: false,
          visible: true
        }, 
        visible: {
          currentStatus: '',
          userStatus: [],
        }
   };


export const SectionJSONTemplate = {
    title: "",
    FieldJSONTemplate
};


export const FormJSONTemplate = {

}


export const initialFieldState = 
  {
    fieldDefinition: {
      name: 'string',
      label: 'string',
      type: 'select',
      dataType: 'select',
      length: 'number',
      description: 'text',
      method: 'select',
      required: 'boolean',
      wrapping: 'boolean',
      visible: 'boolean',
      placeholdertext: 'string',
    //   controlType: 'select',
      barcode: 'boolean',
      options: 'text',
      dependent: 'text',
      config: 'text',
      sessionID: 'text',
      validate: 'select'
     },
    visible: {
        currentStatus: "",
        dependent:{},
        userStatus: []
    },
    validValues: {
        method: 'string',
        configuration: {
            values: [],
            api: {},
            controlType: ''
        }
    },
    data: {
        currentValue: {},
        history: {}
    }
    };


export const formNavigationButton = (hasShadow = false) => ({
  color: '#2b4252',
  ml: hasShadow ? '2px' : '0px',
  minWidth: hasShadow ? '100px' : '100px',
  p: '15px',
  pt: 0,
  pb: 0,
  backgroundColor: 'rgba(43, 66, 82, 0.1)',
  textTransform: 'none',
  cursor: 'pointer',
  boxShadow: hasShadow ? '0px 5px 10px rgba(0, 0, 0, 0.35)' : 'none', // ✅ conditional shadow
  transition: 'box-shadow 0.2s ease-in-out',
  ':hover': {
    backgroundColor: 'var(--tab-button-color)',
  },
  '&.Mui-disabled': {
    color: 'grey',
  },
  '.MuiButton-startIcon': {
    marginRight: '2px',
  },
});
